/**
 * StatsTracker - Shows XP and Collectibles on the left side
 */

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../state/store';
import { inventorySystem } from '../../game/systems/InventorySystem';

export const StatsTracker: React.FC = () => {
  const xp = useSelector((state: RootState) => state.player.xp);
  const level = useSelector((state: RootState) => state.player.level);
  const [collectibles, setCollectibles] = useState<Array<{ name: string; quantity: number }>>([]);

  // Track collectibles
  useEffect(() => {
    const updateCollectibles = () => {
      const items = inventorySystem.getInventory();
      const collectibleItems = items.filter(item => {
        const def = inventorySystem.getItemDefinition(item.itemId);
        return def?.category === 'collectible';
      });

      setCollectibles(collectibleItems.map(item => {
        const def = inventorySystem.getItemDefinition(item.itemId);
        return {
          name: def?.name || item.itemId,
          quantity: item.quantity
        };
      }));
    };

    const interval = setInterval(updateCollectibles, 100);
    updateCollectibles(); // Initial update
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      position: 'fixed',
      top: '140px', // Position below health and stamina bars
      left: '20px',
      background: 'rgba(0, 0, 0, 0.8)',
      border: '2px solid #0f0',
      borderRadius: '8px',
      padding: '15px',
      color: '#0f0',
      fontFamily: 'monospace',
      fontSize: '14px',
      minWidth: '200px',
      maxWidth: '300px',
      zIndex: 999,
      boxShadow: '0 0 20px rgba(0, 255, 0, 0.3)'
    }}>
      {/* XP Section */}
      <div style={{ marginBottom: '15px', borderBottom: '1px solid #0f0', paddingBottom: '10px' }}>
        <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '5px' }}>
          LEVEL: {level}
        </div>
        <div style={{ fontSize: '14px' }}>
          XP: {xp}
        </div>
      </div>

      {/* Collectibles Section */}
      <div>
        <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '8px' }}>
          COLLECTIBLES ({collectibles.length})
        </div>
        <div style={{
          maxHeight: '300px',
          overflowY: 'auto',
          fontSize: '12px'
        }}>
          {collectibles.length === 0 ? (
            <div style={{ color: '#666', fontStyle: 'italic' }}>
              No collectibles yet
            </div>
          ) : (
            collectibles.map((item, idx) => (
              <div
                key={idx}
                style={{
                  padding: '4px 0',
                  borderBottom: idx < collectibles.length - 1 ? '1px solid #0a3a0a' : 'none',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <span>{item.name}</span>
                {item.quantity > 1 && (
                  <span style={{
                    background: '#0a3a0a',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    fontSize: '10px'
                  }}>
                    x{item.quantity}
                  </span>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};
